<template>
    <div class="billing-main-scroll">
        <div class="billing-section-title">{{ $t('common.billing.orderHistory') }}</div>
        <div class="billing-orders-list">
            <div v-for="order in bs.ORDERS" :key="order.id" class="billing-order-row" @click="bs.selectOrder(order.id)">
                <span class="billing-order-id">#{{ order.id }}</span>
                <span class="billing-order-name">{{ order.name }}</span>
                <span class="billing-order-date">{{ bs.formatDate(order.date) }}</span>
                <span class="billing-order-amount">{{ bs.formatPrice(order.amount) }}&#8378;</span>
                <span :class="['billing-order-status', statusClass(order.status)]">{{ statusLabel(order.status) }}</span>
                <span class="billing-order-arrow">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import billingService from './billingService'

export default {
    name: 'BillingOrders',
    computed: {
        bs() {
            return billingService
        },
    },
    methods: {
        statusClass(status) {
            return 'billing-status--' + status
        },
        statusLabel(status) {
            return this.$t('common.billing.status_' + status)
        },
    },
}
</script>
